module.exports = __webpack_public_path__ + "static/img/cmg_logo.0b430ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cmg_logo.png
// module id = 9qno
// module chunks = 1